import stringFormatService from '../../services/stringFormatService';
import stringUtils from '../../utils/stringUtils';
import {config} from '../config';
import configGettersService from './configGettersService';

const getConnectionCareUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.connectingCareUrl);
const getDcsRegisterUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.dcsRegisterUrl);
const getDcsSupportUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.dcsSupportUrl);
const getIqosHomeUrl = () => configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.iqosHomeUrl);
const getIqosHavUrl = () => configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.iqosHavUrl);
const getIqosStoreUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.iqosStoreUrl);
const getLearnMoreUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.learnMoreUrl);
const getLoginUrl = () => configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.loginUrl);
const getProductRegistrationUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.productRegistrationUrl);
const getProductUnregistrationUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.productUnregistrationUrl);
const getTradeInUrl = () => configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.tradeInUrl);
const getPrivacyNoticeUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.privacyNoticeUrl);
const getManualActivationUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.manualActivationUrl);
const getContactUsEmail = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.contactUsEmail);
const getLoyaltyClubDashboardUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.loyaltyClubDashboardUrl);
const getLoyaltyClubHomepageUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.loyaltyClubHomepageUrl);
const getLeviaLearnMoreUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.leviaLearnMoreUrl);
const getLearnHowToUseUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.externalLinks.learnHowToUseUrl);

export default {
    getDcsRegisterUrlFormatted: () => stringFormatService.getLanguageFormattedString(getDcsRegisterUrl()),
    getDcsSupportUrlFormatted: () => stringFormatService.getLanguageFormattedString(getDcsSupportUrl()),
    getIqosHomeUrlFormatted: () => stringFormatService.getLanguageFormattedString(getIqosHomeUrl()),
    getIqosHavUrlFormatted: () => stringFormatService.getLanguageFormattedString(getIqosHavUrl()),
    getIqosStoreUrlFormatted: () => stringFormatService.getLanguageFormattedString(getIqosStoreUrl()),
    getLearnMoreUrlFormatted: () => stringFormatService.getLanguageFormattedString(getLearnMoreUrl()),
    getLoginUrlFormatted: () => stringFormatService.getLanguageFormattedString(getLoginUrl()),
    getContactUsEmailFormatted: () => stringFormatService.getLanguageFormattedString(getContactUsEmail()),
    getProductRegistrationUrlFormatted: () =>
        stringFormatService.getLanguageFormattedString(getProductRegistrationUrl()),
    getLoyaltyClubDashboardUrlFormatted: () =>
        stringFormatService.getLanguageFormattedString(getLoyaltyClubDashboardUrl()),
    getLoyaltyClubHomepageUrlFormatted: () =>
        stringFormatService.getLanguageFormattedString(getLoyaltyClubHomepageUrl()),
    getProductUnregistrationUrlFormatted: () =>
        stringFormatService.getLanguageFormattedString(getProductUnregistrationUrl()),
    getConnectingCareUrlFormatted: (codentify, l1Code) => {
        if (!l1Code || !codentify) return null;

        const url = getConnectionCareUrl();

        if (!url) return null;

        const urlWithCodentify = stringUtils.formatString(url, codentify, l1Code);
        const urlFormatted = stringFormatService.getLanguageFormattedString(urlWithCodentify);

        return urlFormatted;
    },
    getTradeInUrlFormatted: (codentify) => {
        const url = getTradeInUrl();

        if (!url) return null;

        const urlWithCodentify = stringUtils.formatString(url, codentify);
        const urlFormatted = stringFormatService.getLanguageFormattedString(urlWithCodentify);

        return urlFormatted;
    },
    getPrivacyNoticeUrlFormatted: () => stringFormatService.getLanguageFormattedString(getPrivacyNoticeUrl()),
    getManualActivationUrlFormatted: (codentify = '') => {
        const url = getManualActivationUrl();

        if (!url) return null;

        const urlWithCodentify = stringUtils.formatString(url, codentify);
        const urlFormatted = stringFormatService.getLanguageFormattedString(urlWithCodentify);

        return urlFormatted;
    },
    getLeviaLearnMoreUrlFormatted: () => stringFormatService.getLanguageFormattedString(getLeviaLearnMoreUrl()),
    getLearnHowToUseUrlFormatted: () => stringFormatService.getLanguageFormattedString(getLearnHowToUseUrl()),
};
